module.exports = __webpack_public_path__ + "84e1232fbfa513e2997db1413f25dad9.MP3";